/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MediaBaseService } from '../media-base-service';
import { MediaApiConfiguration } from '../media-api-configuration';
import { MediaStrictHttpResponse } from '../media-strict-http-response';

import { LanguageModel } from '../models/language-model';
import { SearchCategoryModel } from '../models/search-category-model';
import { searchClientIdCategoriesLangugeIsoCodeGet$Json } from '../fn/search/search-client-id-categories-languge-iso-code-get-json';
import { SearchClientIdCategoriesLangugeIsoCodeGet$Json$Params } from '../fn/search/search-client-id-categories-languge-iso-code-get-json';
import { searchClientIdCategoriesLangugeIsoCodeGet$Plain } from '../fn/search/search-client-id-categories-languge-iso-code-get-plain';
import { SearchClientIdCategoriesLangugeIsoCodeGet$Plain$Params } from '../fn/search/search-client-id-categories-languge-iso-code-get-plain';
import { searchClientIdLanguageGet$Json } from '../fn/search/search-client-id-language-get-json';
import { SearchClientIdLanguageGet$Json$Params } from '../fn/search/search-client-id-language-get-json';
import { searchClientIdLanguageGet$Plain } from '../fn/search/search-client-id-language-get-plain';
import { SearchClientIdLanguageGet$Plain$Params } from '../fn/search/search-client-id-language-get-plain';
import { searchClientIdPost$Json } from '../fn/search/search-client-id-post-json';
import { SearchClientIdPost$Json$Params } from '../fn/search/search-client-id-post-json';
import { searchClientIdPost$Plain } from '../fn/search/search-client-id-post-plain';
import { SearchClientIdPost$Plain$Params } from '../fn/search/search-client-id-post-plain';
import { searchClientLibraryClientIdGet } from '../fn/search/search-client-library-client-id-get';
import { SearchClientLibraryClientIdGet$Params } from '../fn/search/search-client-library-client-id-get';
import { searchClientPageClientIdGet } from '../fn/search/search-client-page-client-id-get';
import { SearchClientPageClientIdGet$Params } from '../fn/search/search-client-page-client-id-get';
import { SearchResultModel } from '../models/search-result-model';
import { searchSearchPartialClientIdGet } from '../fn/search/search-search-partial-client-id-get';
import { SearchSearchPartialClientIdGet$Params } from '../fn/search/search-search-partial-client-id-get';

@Injectable({ providedIn: 'root' })
export class MediaSearchService extends MediaBaseService {
  constructor(config: MediaApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `searchClientIdLanguageGet()` */
  static readonly SearchClientIdLanguageGetPath = '/Search/{clientId}/Language';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchClientIdLanguageGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchClientIdLanguageGet$Plain$Response(params: SearchClientIdLanguageGet$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<LanguageModel>>> {
    return searchClientIdLanguageGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchClientIdLanguageGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchClientIdLanguageGet$Plain(params: SearchClientIdLanguageGet$Plain$Params, context?: HttpContext): Observable<Array<LanguageModel>> {
    return this.searchClientIdLanguageGet$Plain$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<Array<LanguageModel>>): Array<LanguageModel> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchClientIdLanguageGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchClientIdLanguageGet$Json$Response(params: SearchClientIdLanguageGet$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<LanguageModel>>> {
    return searchClientIdLanguageGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchClientIdLanguageGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchClientIdLanguageGet$Json(params: SearchClientIdLanguageGet$Json$Params, context?: HttpContext): Observable<Array<LanguageModel>> {
    return this.searchClientIdLanguageGet$Json$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<Array<LanguageModel>>): Array<LanguageModel> => r.body)
    );
  }

  /** Path part for operation `searchClientIdCategoriesLangugeIsoCodeGet()` */
  static readonly SearchClientIdCategoriesLangugeIsoCodeGetPath = '/Search/{clientId}/Categories/{langugeIsoCode}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchClientIdCategoriesLangugeIsoCodeGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchClientIdCategoriesLangugeIsoCodeGet$Plain$Response(params: SearchClientIdCategoriesLangugeIsoCodeGet$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<SearchCategoryModel>>> {
    return searchClientIdCategoriesLangugeIsoCodeGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchClientIdCategoriesLangugeIsoCodeGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchClientIdCategoriesLangugeIsoCodeGet$Plain(params: SearchClientIdCategoriesLangugeIsoCodeGet$Plain$Params, context?: HttpContext): Observable<Array<SearchCategoryModel>> {
    return this.searchClientIdCategoriesLangugeIsoCodeGet$Plain$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<Array<SearchCategoryModel>>): Array<SearchCategoryModel> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchClientIdCategoriesLangugeIsoCodeGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchClientIdCategoriesLangugeIsoCodeGet$Json$Response(params: SearchClientIdCategoriesLangugeIsoCodeGet$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<SearchCategoryModel>>> {
    return searchClientIdCategoriesLangugeIsoCodeGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchClientIdCategoriesLangugeIsoCodeGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchClientIdCategoriesLangugeIsoCodeGet$Json(params: SearchClientIdCategoriesLangugeIsoCodeGet$Json$Params, context?: HttpContext): Observable<Array<SearchCategoryModel>> {
    return this.searchClientIdCategoriesLangugeIsoCodeGet$Json$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<Array<SearchCategoryModel>>): Array<SearchCategoryModel> => r.body)
    );
  }

  /** Path part for operation `searchClientIdPost()` */
  static readonly SearchClientIdPostPath = '/Search/{clientId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchClientIdPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  searchClientIdPost$Plain$Response(params: SearchClientIdPost$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<SearchResultModel>>> {
    return searchClientIdPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchClientIdPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  searchClientIdPost$Plain(params: SearchClientIdPost$Plain$Params, context?: HttpContext): Observable<Array<SearchResultModel>> {
    return this.searchClientIdPost$Plain$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<Array<SearchResultModel>>): Array<SearchResultModel> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchClientIdPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  searchClientIdPost$Json$Response(params: SearchClientIdPost$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<SearchResultModel>>> {
    return searchClientIdPost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchClientIdPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  searchClientIdPost$Json(params: SearchClientIdPost$Json$Params, context?: HttpContext): Observable<Array<SearchResultModel>> {
    return this.searchClientIdPost$Json$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<Array<SearchResultModel>>): Array<SearchResultModel> => r.body)
    );
  }

  /** Path part for operation `searchClientLibraryClientIdGet()` */
  static readonly SearchClientLibraryClientIdGetPath = '/Search/ClientLibrary/{clientId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchClientLibraryClientIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchClientLibraryClientIdGet$Response(params: SearchClientLibraryClientIdGet$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<void>> {
    return searchClientLibraryClientIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchClientLibraryClientIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchClientLibraryClientIdGet(params: SearchClientLibraryClientIdGet$Params, context?: HttpContext): Observable<void> {
    return this.searchClientLibraryClientIdGet$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `searchSearchPartialClientIdGet()` */
  static readonly SearchSearchPartialClientIdGetPath = '/Search/SearchPartial/{clientId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchSearchPartialClientIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchSearchPartialClientIdGet$Response(params: SearchSearchPartialClientIdGet$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<void>> {
    return searchSearchPartialClientIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchSearchPartialClientIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchSearchPartialClientIdGet(params: SearchSearchPartialClientIdGet$Params, context?: HttpContext): Observable<void> {
    return this.searchSearchPartialClientIdGet$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `searchClientPageClientIdGet()` */
  static readonly SearchClientPageClientIdGetPath = '/Search/ClientPage/{clientId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchClientPageClientIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchClientPageClientIdGet$Response(params: SearchClientPageClientIdGet$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<void>> {
    return searchClientPageClientIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchClientPageClientIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchClientPageClientIdGet(params: SearchClientPageClientIdGet$Params, context?: HttpContext): Observable<void> {
    return this.searchClientPageClientIdGet$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<void>): void => r.body)
    );
  }

}
